import { useEffect, useRef } from 'react';

interface HeadMeta {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
}

export function useDocumentHead({ title, description, keywords, canonicalUrl }: HeadMeta) {
  const metaRef = useRef<{ desc: HTMLMetaElement | null; kw: HTMLMetaElement | null; canonical: HTMLLinkElement | null }>({ desc: null, kw: null, canonical: null });

  useEffect(() => {
    document.title = title;

    let descEl = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!descEl) {
      descEl = document.createElement('meta');
      descEl.name = 'description';
      document.head.appendChild(descEl);
    }
    descEl.content = description;
    metaRef.current.desc = descEl;

    if (keywords) {
      let kwEl = document.querySelector('meta[name="keywords"]') as HTMLMetaElement;
      if (!kwEl) {
        kwEl = document.createElement('meta');
        kwEl.name = 'keywords';
        document.head.appendChild(kwEl);
      }
      kwEl.content = keywords;
      metaRef.current.kw = kwEl;
    }

    if (canonicalUrl) {
      let linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!linkEl) {
        linkEl = document.createElement('link');
        linkEl.rel = 'canonical';
        document.head.appendChild(linkEl);
      }
      linkEl.href = canonicalUrl;
      metaRef.current.canonical = linkEl;
    }
  }, [title, description, keywords, canonicalUrl]);
}